import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import images from '../constants/images'
import SchTable from '../components/Table/SchTable'
import SchTableTwo from '../components/Table/SchTableTwo'

import ImageEnlarge from '../components/ImageEnlarge/ImageEnlarge'


const Schedules = () => {

  const scheduleData1 = [
    {
      time: 'MONDAY 5:00PM - 6:30PM',
      fieldA: '-',
      fieldB1: '-',
      fieldB2: '-',
      fieldC1: 'U12-15Boy*',
      fieldC2: 'U12-15Boy*',    
      fieldD1: '-',
      fieldD2: '-',
      fieldE1: 'U8 T1 Rec',
      fieldE2: '-',
      fieldF: '-'
    },
    {
      time: 'MONDAY 5:30PM - 7:00PM',
      fieldA: 'U6 T2 REC',
      fieldB1: 'U13-14Girls*',
      fieldB2: 'U13-14Girls*',
      fieldC1: 'U12-15Boys*',
      fieldC2: 'U12-15Boys*',    
      fieldD1: 'U12-15Boys*',
      fieldD2: 'U12-15Boys*',
      fieldE1: '-',
      fieldE2: '-',
      fieldF: '-'
    },
    //TUESDAY
    {
      time: 'TUESDAY 4:30PM - 5:30PM',
      fieldA: '-',
      fieldB1: '-',
      fieldB2: '-',
      fieldC1: '-',
      fieldC2: '-',    
      fieldD1: 'U8 T3 REC',
      fieldD2: '-',
      fieldE1: '-',
      fieldE2: 'U8 T4 REC',
      fieldF: '-'
    },
    {
      time: 'TUESDAY 5:30PM - 7:00PM',
      fieldA: '-',
      fieldB1: 'U11Boys*',
      fieldB2: 'U12Boys*',
      fieldC1: 'U12 REC',
      fieldC2: 'U12 REC',    
      fieldD1: 'U10B A.K Red*',
      fieldD2: 'U10 S.S.K Purple*',
      fieldE1: 'U10Girls',
      fieldE2: '-',
      fieldF: '-'
    },
    
    // WEDNESDAY
    {
      time: 'WEDNESDAY 5:00PM - 6:30PM',
      fieldA: '-',
      fieldB1: 'U12-15Boys*',
      fieldB2: 'U12-15Boys*',
      fieldC1: 'U12-15Boys*',
      fieldC2: 'U12-15Boys*',    
      fieldD1: '-',
      fieldD2: '-',
      fieldE1: 'U8 T2 REC',
      fieldE2: '-',
      fieldF: '-'
    },
    {
      time: 'WEDNESDAY 5:30PM - 7:00PM',
      fieldA: 'U6 T3 REC',
      fieldB1: 'U11Boys',
      fieldB2: '-',
      fieldC1: '-',
      fieldC2: '-',    
      fieldD1: '-',
      fieldD2: '-',
      fieldE1: 'U10 T1 REC',
      fieldE2: 'U10Girls*',
      fieldF: 'U6 T4 REC'
    },
    // THURSDAY
    {
      time: 'THURSDAY 4:30PM - 5:30PM',
      fieldA: 'U6 T1 REC',
      fieldB1: '-',
      fieldB2: '-',
      fieldC1: '-',
      fieldC2: '-',    
      fieldD1: '-',
      fieldD2: '-',
      fieldE1: 'U10 T2 REC',
      fieldE2: '-',
      fieldF: 'U6 T5 REC'
    },
    {
      time: 'THURSDAY 5:30PM - 7:00PM',
      fieldA: 'U6 T2 REC',
      fieldB1: 'U11-Boys*',
      fieldB2: 'U11Boys*',
      fieldC1: 'U13-14Girls*',
      fieldC2: 'U13-14Girls*',    
      fieldD1: 'U10 A.K.Red*',
      fieldD2: 'U10 S.S.K Purple*',
      fieldE1: '-',
      fieldE2: '-',
      fieldF: '-'
    },
    //Friday
    {
      time: 'FRIDAY 4:30PM - 5:30PM',
      fieldA: '-',
      fieldB1: 'U12 REC',
      fieldB2: 'U12 REC',
      fieldC1: '-',
      fieldC2: '-',    
      fieldD1: '-',
      fieldD2: '-',
      fieldE1: 'U10 T2 REC',
      fieldE2: '-',
      fieldF: '-'
    },    
    {
      time: 'FRIDAY 5:30PM - 7:00PM',
      fieldA: '-',
      fieldB1: '-',
      fieldB2: '-',
      fieldC1: 'U12-15Boys*',
      fieldC2: 'U12-15Boys*',    
      fieldD1: 'U12-15Boys*',
      fieldD2: 'U12-15Boys*',
      fieldE1: '-',
      fieldE2: '-',
      fieldF: '-'
    },
  ];
const scheduleDataTwo =[
  {
    time: 'MONDAY 4:30PM - 5:30PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time: 'MONDAY 5:30PM - 7:00PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time:'TUESDAY 4:30PM - 5:30PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time:'TUESDAY 5:30PM - 7:00PM',
    fieldL1a: 'U9BLACK*',
    fieldL1b: '-',
    fieldL2a: 'U9CITY*',
    fieldL2b: '-'
  },
  {
    time:'WEDNESDAY 4:30PM - 5:30PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time:'WEDNESDAY 5:30PM - 7:00PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time:'THURSDAY 4:30PM - 5:30PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time:'THURSDAY 5:30PM - 7:00PM',
    fieldL1a: 'U9BLACK*',
    fieldL1b: '-',
    fieldL2a: 'U9CITY*',
    fieldL2b: '-'
  },
  {
    time:'FRIDAY 4:30PM - 5:30PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
  {
    time:'FRIDAY 5:30PM - 7:00PM',
    fieldL1a: '-',
    fieldL1b: '-',
    fieldL2a: '-',
    fieldL2b: '-'
  },
]
  return (
    <div>
      <Navbar />
      <div className="app__content flex__center app__background">
        <h1 className="headtext__roboto schedule__header" style={{ paddingTop: '2rem', }}>Field & Schedule</h1>
        <div>
          <h3 className="subheadtext__roboto">Training Schedule</h3>
          <p className="p__opensans">^ Recreation Team | * Competitive Team</p>
        </div>
        <div>      
          <div>
          <p className="p__opensans" style={{textAlign:'center'}}>CR.Hanna Field Location</p>
          <ImageEnlarge className="scheduleImg" src={images.field_map} alt="field map" />          
          </div>
          <div>
            <p className="p__opensans" style={{textAlign:'center'}}>CR.Hanna Parking</p>
           <ImageEnlarge className="scheduleImg" src={images.crParking} alt="cr parking" />
          </div>
          <div></div>
          <div style={{marginTop:'10px'}}>
          <SchTable dataSch={scheduleData1} />                   
          <div style={{marginBottom:'15px'}}>
            <p className="p__opensans"style={{textAlign:'center'}}>Love Park Field Map</p>
            <ImageEnlarge className="scheduleImg" src={images.lovePark} alt="field map" />
          </div>
          <SchTableTwo dataSchTwo={scheduleDataTwo}/>
          </div>         
        </div>           
      </div>    
      <Footer />
    </div>
  )
}

export default Schedules